import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function About() {
  return (
    <section
      id="about"
      className="relative px-6 md:px-12 lg:px-24 py-24 md:py-32 lg:py-40"
      data-testid="about-section"
    >
      <div className="grid grid-cols-12 gap-y-16 lg:gap-x-12">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="col-span-12 lg:col-span-5"
        >
          <h2
            className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-cream"
            data-testid="about-heading"
          >
            Luxury is a feeling
            <br />
            you <span className="italic gold-text-gradient">come home</span> to.
          </h2>
          <div className="mt-12 h-px w-24 bg-gold/50" />
        </motion.div>

        <div className="col-span-12 lg:col-span-6 lg:col-start-7 flex flex-col justify-end gap-8">
          <motion.p
            variants={fadeUp}
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            className="text-base md:text-lg font-light leading-relaxed text-taupe"
            data-testid="about-paragraph-1"
          >
            ZENIQUE is a residential design and furnishing company that partners with
            developers, home builders and property companies to take customers from new
            property to finished home.
          </motion.p>
          <motion.p
            variants={fadeUp}
            custom={2}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            className="text-base md:text-lg font-light leading-relaxed text-taupe"
            data-testid="about-paragraph-2"
          >
            We design the interiors, curate the furniture and products, and coordinate the
            final installation, creating a simpler way for people to move into a home that
            already feels like theirs.
          </motion.p>
        </div>
      </div>

      <div className="mt-24 md:mt-32 border-t border-gold/15 pt-20 md:pt-24 text-center">
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          className="mx-auto max-w-4xl font-serif font-light text-3xl md:text-4xl lg:text-5xl leading-snug text-cream"
          data-testid="about-statement"
        >
          We create interiors that balance aesthetics, functionality, and individuality
          to reflect the people who call them{" "}
          <span className="italic gold-text-gradient">home.</span>
        </motion.p>
      </div>
    </section>
  );
}
